//@flow

export const ConfigItemType = {
  BANNER: 'banner',
  HELLO_BAR: 'helloBar',
};

export const ConfigItemStatus = {
  ACTIVE: 'active',
  DISABLED: 'disabled',
};

export const ActivationConditionStateValueName = {
  IS_MEMBER: 'isMember',
  IS_LOGGED_IN: 'isLoggedIn',
};

export const ActivationConditionType = {
  STATE_VALUE: 'stateValue',
  TIME: 'time',
  PATH: 'path',
  QUERY: 'query',
  HOST: 'host',
};

export const ActivationConditionMatchType = {
  STARTS_WITH: 'startsWith',
  EXACT: 'exact',
  NOT_EQUAL: 'notEqual',
};

export type ActivationCondition = {
  type:typeof ActivationConditionType,
  value:string,
  name?:string,
  match?:typeof ActivationConditionMatchType,
  start?:string,
  end?:string,
};

export type ActivationConfigOperator = 'and'|'or';

export type ActivationConfigParam = {
  operator:ActivationConfigOperator,
  conditions:ActivationCondition[],
};

export type ActivationConfig = {
  operator:ActivationConfigOperator,
  params:ActivationConfigParam[],
};


export type HelloBarStyles = {
  color:string,
  backgroundColor:string,
};

export type HelloBarMeta = {
  styles:HelloBarStyles,
};

export type BannerUiConfig = {
  className?:string,
  imageSmall?:string,
  imageMedium?:string,
  imageLarge?:string,
  imageXlarge?:string,
  imageXXlarge?:string,
  title?:string,
  text1?:string,
  text2?:string,
  text3?:string,
  text4?:string,
  link?:string,
  isExternalLink?:boolean,
  styles?:string,
};

export type BannerConfig = {
  items:BannerUiConfig[],
};

export type HelloBarConfig = {
  text:string,
  link:string,
  meta?:string,
  renderMarkup?:boolean,
};


export type ConfigItem = {
  _id:string,
  createdAt:Date,
  updatedAt:Date,
  type:typeof ConfigItemType,
  status:typeof ConfigItemStatus,
  title:string,
  priority:number,
  activationConfig:ActivationConfig,
  bannerConfig?:BannerConfig,
  helloBarConfig?:HelloBarConfig,
};

export type ConfigItemsState = {
  [key:string]:ConfigItem,
};
